import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CaffeinateMailingSchema = withDefaults({
  type: 'caffeinate-mailing',
  objectExtensions: ['caffeinate-mailing'],
  fields: [
    {
      kind: 'attribute',
      name: 'sendAt',
    },
    {
      kind: 'attribute',
      name: 'sentAt',
    },
    {
      kind: 'attribute',
      name: 'skippedAt',
    },
    {
      kind: 'attribute',
      name: 'mailerClass',
    },
    {
      kind: 'attribute',
      name: 'mailerAction',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'templateSubstitutions',
    },
    {
      kind: 'belongsTo',
      name: 'caffeinateCampaignSubscription',
      type: 'caffeinate-campaign-subscription',
      options: {
        async: false,
        inverse: 'caffeinateMailings',
      },
    },
    {
      kind: 'belongsTo',
      name: 'notificationHistory',
      type: 'notification-history',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default CaffeinateMailingSchema;
